import axios from 'axios'
export default {

  async add (payment) {
    try {
      const response = await axios.post('payments/add', payment)
      if (response.status === 200) {
        return response.data
      } else {
        return null
      }
    } catch (error) {
      return null
    }
  }

}
